import { useEffect, useState } from 'react';

import { isNativeApp } from 'utils/nativeOAuth';

/**
 * Client-side, SSR-safe check for whether we're running inside the native
 * Capacitor wrapper (vs. a normal web browser).
 *
 * Returns `false` during SSR and the first client render, then resolves to the
 * real value after mount. This avoids a hydration mismatch (the server can't
 * know about `window.Capacitor`) and the brief flash that a direct
 * `isNativeApp()` call in render would cause.
 */
export function useIsNativeApp(): boolean {
  const [native, setNative] = useState(false);
  useEffect(() => {
    setNative(isNativeApp());
  }, []);
  return native;
}
